export default __webpack_public_path__ + "static/media/global-mba-graduation-group-v1.ddbb9eba.webp";